import type { ComponentPropsWithRef } from "react";
import type { ImageType } from "@/types";
import { cn } from "@/utils/style.ts";
import { isText } from "@/utils/types.ts";
import ResponsiveImage from "./responsive-image.tsx";

type Props = Omit<ComponentPropsWithRef<"img">, "src"> & { image: ImageType };
export default function Image({ image, ...props }: Props) {
    return isText(image) ? (
        <img {...props} className={cn("responsive-image", props.className)} src={image} alt={props.alt ?? ""} />
    ) : (
        <ResponsiveImage {...props} image={image} />
    );
}
